import { render, staticRenderFns } from "./CourseConfigTile.vue?vue&type=template&id=683884e0&scoped=true&"
import script from "./CourseConfigTile.vue?vue&type=script&lang=js&"
export * from "./CourseConfigTile.vue?vue&type=script&lang=js&"
import style0 from "./CourseConfigTile.vue?vue&type=style&index=0&id=683884e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683884e0",
  null
  
)

export default component.exports